module.exports = __webpack_public_path__ + "static/media/boat-boating-jet-svgrepo-com.c2f06dea.svg";